export default {
  from: {
    new: 'Novo',
    'delivery-from': 'Entrega de',
  },
  to: {
    delivered: 'Entregue a',
    deliver: 'Entregar a',
  },
  comment: 'Comentário do estafeta',
}
